"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfileSaga = getProfileSaga;
exports.getDeliveryAddressesSaga = getDeliveryAddressesSaga;
exports.deleteDeliveryAddressesSaga = deleteDeliveryAddressesSaga;
exports.addDeliveryAddressesSaga = addDeliveryAddressesSaga;
exports.default = customerSaga;
const tslib_1 = require("tslib");
const effects_1 = require("redux-saga/effects");
const CustomerApi_1 = tslib_1.__importDefault(require("../../../api/customer/CustomerApi"));
const ActionEnums_1 = require("../../../enums/ActionEnums");
const CustomerActions_creators_1 = tslib_1.__importDefault(require("../actions/CustomerActions.creators"));
function* getProfile() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield (0, effects_1.getContext)('aemConfiguration');
        const response = yield (0, effects_1.call)(CustomerApi_1.default.getProfile, servicesEndpoint, defaultRequestParams);
        yield (0, effects_1.put)(CustomerActions_creators_1.default.setProfile(response));
    }
    catch (_a) { }
}
function* getDeliveryAddresses() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield (0, effects_1.getContext)('aemConfiguration');
        const response = yield (0, effects_1.call)(CustomerApi_1.default.deliveryAddress, servicesEndpoint, defaultRequestParams);
        yield (0, effects_1.put)(CustomerActions_creators_1.default.setDeliveryAddresses(response));
    }
    catch (_a) { }
}
function* deleteDeliveryAddress(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield (0, effects_1.getContext)('aemConfiguration');
        yield (0, effects_1.call)(CustomerApi_1.default.deleteDeliveryAddress, servicesEndpoint, defaultRequestParams, action.payload);
        yield (0, effects_1.put)(CustomerActions_creators_1.default.getDeliveryAddresses());
    }
    catch (_a) { }
}
function* addDeliveryAddress(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield (0, effects_1.getContext)('aemConfiguration');
        yield (0, effects_1.call)(CustomerApi_1.default.addDeliveryAddress, servicesEndpoint, defaultRequestParams, action.payload);
    }
    catch (_a) { }
}
function* getProfileSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.CustomerActionTypes.GET_PROFILE, getProfile);
}
function* getDeliveryAddressesSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.CustomerActionTypes.GET_DELIVERY_ADDRESSES, getDeliveryAddresses);
}
function* deleteDeliveryAddressesSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.CustomerActionTypes.DELETE_DELIVERY_ADDRESS, deleteDeliveryAddress);
}
function* addDeliveryAddressesSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.CustomerActionTypes.ADD_DELIVERY_ADDRESS, addDeliveryAddress);
}
function* customerSaga() {
    yield (0, effects_1.all)([getProfileSaga(), getDeliveryAddressesSaga(), deleteDeliveryAddressesSaga(), addDeliveryAddressesSaga()]);
}
